import { createFileRoute } from "@tanstack/react-router";

import { WerkflowInstancesSettings } from "../components/settings/WerkflowInstancesSettings";

export const Route = createFileRoute("/settings/erp-instances")({
  component: WerkflowInstancesSettings,
});
